var React = require('react');

function IcNavSessions (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 4c0-1.103-.897-2-2-2s-2 .897-2 2v6c0 1.103.897 2 2 2s2-.897 2-2V4zM4 4c0-2.209 1.791-4 4-4s4 1.791 4 4v6c0 2.209-1.791 4-4 4s-4-1.791-4-4V4zm12 6V8h-2v2c0 3.309-2.691 6-6 6s-6-2.691-6-6V8H0v2c0 4.0793 3.0539 7.4459 7 7.9381V21h2v-3.0619c3.9461-.4922 7-3.8588 7-7.9381z","fill":"currentColor"}));
}

IcNavSessions.defaultProps = {"fill":"none","viewBox":"0 0 16 21"};

module.exports = IcNavSessions;

IcNavSessions.default = IcNavSessions;
